<template>
	<div class="inputContentBox">
		<yd-cell-group>
			<span class="title">{{title}}</span>
			<yd-cell-item type="label">
				<select slot="right" v-model="value" disabled="true">
					<option v-for="item in option" :key="item.id" :value="item.id">{{item.name}}</option>
				</select>
			</yd-cell-item>
			<div class="select" @click="changeShow"></div>
		</yd-cell-group>
		<yd-actionsheet :items="selectItem" v-model="selectShow" cancel="取消"></yd-actionsheet>
		<div class="tip" v-if="!value" @click="changeShow">{{text}}</div>
	</div>
</template>

<script>
	export default {
		name: "inputComponent",
		props: ["title", "text", "type", "value", "changeAble"],
		data() {
			return {
				selectShow: false,
				option: [],
				selectItem: [],
			};
		},
		mounted() {
			this.init();
		},
		methods: {
			changeShow: function () {
				if (!this.changeAble) {
					this.selectShow = true;
				}
			},
			checkSubmit: function () {
				if (!this.value) {
					this.$common.errTip(this.title + "不能为空！");
					this.selectShow = true;
					return false;
				}
				return true;
			},
			init: function () {
				if (this.type == "edu") {
					this.option = [
						{id: "1", name: "小学"},
						{id: "2", name: "初中"},
						{id: "3", name: "高中"},
						{id: "4", name: "大专"},
						{id: "5", name: "本科"},
						{id: "6", name: "硕士"},
						{id: "7", name: "博士"}
					];
				} else if (this.type == "maritalStatus") {
					this.option = [
						{id: "1", name: "未婚"},
						{id: "2", name: "已婚"},
						{id: "3", name: "离异"},
						{id: "4", name: "丧偶"}
					];
				} else if (this.type == "contactRel") {
					this.option = [
						{id: "1", name: "父母"},
						{id: "2", name: "子女"},
						{id: "3", name: "亲属"},
						{id: "4", name: "同事"},
						{id: "5", name: "朋友"}
					];
				} else if (this.type == "postType") {
					this.option = [
						{id: "1", name: "法人"},
						{id: "2", name: "股东"},
						{id: "3", name: "私营业主"},
						{id: "4", name: "个体工商户"},
						{id: "5", name: "500强"},
						{id: "6", name: "上市公司"},
						{id: "7", name: "国企"},
						{id: "8", name: "金融机构"},
						{id: "9", name: "事业单位正式员工"},
						{id: "10", name: "公务员"},
						{id: "11", name: "普通企业正式员工"},
						{id: "12", name: "其他"}
					];
				} else if (this.type == "status") {
					this.option = [
						{id: "1", name: "有效"},
						{id: "0", name: "无效"},
					];
				} else if (this.type == "payWay") {
					this.option = [
						{id: "1", name: "月缴"},
						{id: "2", name: "季缴"},
						{id: "3", name: "半年缴"},
						{id: "4", name: "年缴"},
						{id: "5", name: "趸缴"},
					];
				} else if (this.type == "insure") {
					this.option = [
						{id: "1", name: "分红险"},
						{id: "2", name: "传统险"},
						{id: "3", name: "投连险"},
						{id: "4", name: "万能险"},
					];
				}else if (this.type == "houseIsLoan") {
					this.option = [{id: "0", name: "否"}, {id: "1", name: "是"}];
				}
				var that = this;
				for (var i = 0; i < this.option.length; i++) {
					var item = {
						label: this.option[i].name,
						id: this.option[i].id,
						callback: (res) => {
							that.$emit("input", res.id);
						}
					};
					this.selectItem.push(item);
				}
			}
		}
	};
</script>

<style>
	.contentBox .yd-cell-item .yd-cell-right select {
		height: 0.5rem !important;
		line-height: 0.5rem !important;
		color: #555 !important;
		margin-left: 0 !important;
		text-indent: 0.1rem !important;
		padding: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/inputComponent/selectComponent.vue